type CompanyUser = {
  id: string
  emailVerified: boolean
}

/**
 * Check if the company user's email is verified, based on the given company user ID.
 *
 * @param companyUsers - List of company users.
 * @param companyMemberId - Company user ID.
 */
function isCompanyUserEmailVerified<T extends CompanyUser>(
  companyUsers: Array<T>,
  companyMemberId: string,
) {
  const companyMember = companyUsers.find(user => user.id === companyMemberId)

  return !!companyMember?.emailVerified
}

export default isCompanyUserEmailVerified
